export default __webpack_public_path__ + "static/media/groupe484.1db4c00a.svg";